<template lang="pug">
#quc-login-pane(v-show="visible" :style="position")
  i.arrow
  .quc-wrapper.quc-page(ref="injector")
  .divider
  p.dj-tip 如果您是
    b 有效的点睛客户
    | ，可直接用点睛帐号登录360分析，直接开通无需重新注册。
  p
    a.newuser(href="http://i.360.cn/reg?destUrl=http://fenxi.businessdata.360.cn/")
      | 新用户，立即注册
</template>

<script>
export default {
  props: {
    system: String,
    types: String,
    reload: [Boolean, String],
    redirect: {
      type: String,
      require: true,
    },
    charset: {
      type: String,
      default: 'utf-8',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      domainList: ['360.cn'],
      thirdLogin: [],
      position: {},
    };
  },
  computed: {
    opts() {
      return {
        src: this.system,
        reloadAfterLogout: this.reload || true,
        domainList: ['360.cn'],
        charset:
          document.charset ||
          document.defaultCharset ||
          document.characterSet ||
          'UTF-8',
        protocol: location.protocol.replace(':', ''),
        proxy: location.protocol + '//' + location.host + '/psp_jump.html',
        ignoreCookie: false,
        useMonitor: true, //当为HTTPS时，关闭统计
      };
    },
    signInOpts() {
      return {
        wrapper: this.$refs.injector,
        types: this.types.split(','),
        panelTitle: '欢迎登录360分析',
        thirdPart: {
          providers: [],
        },
      };
    },
  },
  watch: {
    visible(newVal) {
      if (!newVal) return;

      const container = this.$el.parentNode;
      const rect = container.getBoundingClientRect();
      this.position = {
        top: `${rect.height + 2}px`,
        right: '0px',
      };
    },
  },
  mounted() {
    if (typeof QHPass === 'undefined') {
      return;
    }

    QHPass.init(this.opts);
    QHPass.setConfig('signIn.types', this.signInOpts.types);
    QHPass.signIn(this.$refs.injector, () => {
      // reset crowd list
      localStorage.__fx_selected_crowd = '[]';
      return (location.href = this.redirect || '/');
    });
    // const a = document.createElement('a');
    // a.href = 'http://i.360.cn/findpwd/';
    // a.setAttribute('target', '_blank');
    // a.innerHTML = '忘记密码?';
    // this.$refs.injector
    //   .querySelector('.quc-field.quc-field-submit')
    //   .appendChild(a);
  },
};
</script>

<style>
.quc-mod-sign-in .quc-main {
  margin-top: -10px;
  padding: 0;
  width: auto;
}

.quc-tip-wrapper {
  padding-top: 5px;
  height: 30px;
  line-height: 30px;
}

.quc-tip-wrapper .quc-tip-error {
  color: red;
}

.quc-field .quc-input-bg {
  display: inline-block;
  width: 100%;
  border: 1px solid #dadfe6;
}

.quc-field.quc-field-password .quc-input-bg {
  display: inline-block;
  width: 100%;
  border: 1px solid #dadfe6;
}

.quc-checkbox-keep-alive {
  margin-right: 6px;
}

.quc-button-sign-in {
  margin-left: 2px;
  width: 160px;
  height: 40px;
  border: none;
  border-radius: 20px;
  background: #465467;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.quc-button-sign-in:hover {
  background: #606d80;
}

.quc-button-sign-in:active {
  background: #4289cc;
}

.quc-field-captcha .quc-input-bg {
  margin-bottom: 10px;
}

.quc-field-captcha img {
  vertical-align: middle;
}

.quc-input-bg label.quc-placeholder {
  position: absolute;
  z-index: 130200;
  color: #a9a9a9;
  cursor: text;
}

.quc-field-captcha,
.quc-field-keep-alive,
.quc-field-third-part,
.quc-footer {
  display: none;
}

.quc-label {
  display: block;
  margin: 14px 0;
  color: #66728c;
  font-size: 14px;
  font-weight: normal;
}

.quc-field-submit {
  margin-top: 25px;
  text-align: left;
}

#quc-login-pane-btn.on {
  background-color: #fff;
  color: #3b3d3e;
}

#quc-login-pane-btn {
  padding: 5px 1em;
  border: 1px solid #fff;
  border-radius: 15px;
  color: #fff;
}

#quc-login-pane {
  position: absolute;
  z-index: 9999;
  right: 0;
  border: 1px solid #e6ebf1;
  background: rgba(255, 255, 255);
  font-family: Microsoft Yahei;
  line-height: normal;
  border-radius: 4px;
  padding-bottom: 20px;
}

#quc-login-pane p {
  font-size: 14px;
  padding: 0 30px;
}

#quc-login-pane p a {
  display: inline;
  padding: 0;
  border: 0;
  color: #738699;
  text-decoration: none;
  font-size: 12px;
}

#quc-login-pane p a:hover {
  color: #7e878e;
}

#quc-login-pane p .newuser {
  display: inline-block;
  margin: 0;
  width: 100%;
  height: 40px;
  border-radius: 2px;
  background-color: rgb(54, 180, 71, 0.6);
  color: #fff;
  text-align: center;
  line-height: 40px;
}

#quc-login-pane p .newuser:hover {
  background-color: rgb(54, 180, 71);
  color: #fff;
}

#quc-login-pane hr {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 0;
  border-top: 1px solid #ddd;
}

#quc-login-pane .arrow:after {
  border-bottom-color: #f0efee;
}

#quc-login-pane .arrow {
  position: absolute;
  top: -10px;
  right: 18px;
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-top-width: 0;
  border-bottom-color: rgba(255, 255, 255, 0.95);
}

#quc-login-pane .dj-tip {
  font-size: 12px;
  font-style: italic;
  color: #36b447;
  padding-left: 50px;
  line-height: 1.6;
  margin: 10px 0;
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAOpJREFUOE+lk8EOwUAQhv/xQg6iPTtoI9ZVQngH4saZm/AOhMTVirQOzq04eCEjbVPZbnWD7ml3Z+bb+WdmCSUXfYq3jy0H4BoqXI3tT3oAdA86Z1/3zwEs6U4BzAsSm4XCW6i2DMCSLn+jKBTeO+69saS7A9DT6MvozMBEA+9D4fWjuxhgn5wmM+X0PZkakb1CfM1pJ3aCtn9JANIdMbDSnYwAYBwIbx0D6tLZEGjwC4DB25vwh0YAQN0EygcdngEUSTB1hFQJRUU0ZUBqEaOXPrXRkEG2jaljqUFSIP+Pcgop9Zm++QuqzwvD5moR6yGyhwAAAABJRU5ErkJggg==')
    30px 1px no-repeat;
}
#quc-login-pane .dj-tip > b {
  color: #22752d;
}

#quc-login-pane .divider {
  width: 100%;
  height: 30px;
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP4AAAAeCAMAAAA7DFPhAAAAclBMVEUAAAD////+/v/a3+ba3+ba3+bq7fHa3+ba3+bj5+za3+ba3+bd4uj19vjM09rs7/Lp7O/a3+b8/P29xtDy9Pby9Pa7xc7EzNTa3+ba3+bi5uvi5uvQ1t26w83AydLa3+ba3+ba3+bM09ra3+bO09i4wsylbHHpAAAAJHRSTlMATU7+Hnl/86eh+eRxYKB4ZVhS22dZ5765uKyrlPPQIE7XoSKnz9ekAAABAklEQVRYw+3YyXbDIAwFUD1hPOAxxPGQsRP//4ulbnzaxFmzEXdhttYRCCSKoii8RE+lyd5nfSN5klyd0traPj2pPCFh3rKCccdFtiNRKpXin1ZVJMhO9XjQK0H5T7IWT9pMzvnPC2wUOQmRKMYGKynp10d4eu/c9QA4v/oFR00yzCmA7nJFNewBd+k0vHQmGcoaQPOT8rOr4EYs6pJkMBbAOADo3BmuwcIaCu8rsN/wmXkc/MeHz+6DF9aE/x8Kbrv5G2Gbf1pLX7eUvgYQVfr+Lr7xcA9f0sV3e/3sEdP2y370Sm95hDe80scd0odd66iTuRY56lwH3aac9CdFURTYN1prLZ+z5BiHAAAAAElFTkSuQmCC')
    center center no-repeat;
}
</style>



// WEBPACK FOOTER //
// login.vue?a2e8ef1c